<template>
<main class="situation situation-detail">
  <h1 class="heading-common is-btn-back"><a class="btn-back" @click="back"></a> {{ section_data ? section_data.title: '' }}</h1>

  <!-- Container -->
  <section class="container" v-show="isLoading">
    <div class="flex-center">
    
      <div class="row">
      <template v-if="lessonList && lessonList.length">
        <ul class="situation-list">
          <li class="box" v-for="(lesson, lesson_idx) in lessonList" :key="lesson_idx">
            <div class="title">{{ lesson.lesson_number }}. {{ lesson.title }}
                <div class="situation-status" :class="lesson.status"></div>
            </div>
            <div class="situation-data-box">
              <div class="situation-data left">
                <div class="situation-progress">
                  <div class="progress-label">
                    <div class="label-correct">{{ $t('lesson.question.title') }} {{ $t('profile.correct_rate') }}</div>
                    <div class="correct-rate">{{ lesson.question_rate  }}%</div>
                  </div>
                  <div class="progress-bar">
                    <div class="progress-rate" :style="{ width: lesson.question_rate + '%' }"></div>
                  </div>
                </div>
              </div>
              <div class="situation-data right">
                <div class="situation-progress">
                  <div class="progress-label">
                    <div class="label-correct">{{ $t('lesson.exam.title') }} {{ $t('profile.correct_rate') }}</div>
                    <div class="correct-rate">{{ lesson.exam_rate  }}%</div>
                  </div>
                  <div class="progress-bar">
                    <div class="progress-rate" :style="{ width: lesson.exam_rate + '%' }"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <button type="button" class="button button-default next" :class="(lesson.status!='completed') ? 'disabled' : ''" @click="selectLessonItem(lesson)">{{ $t('profile.to_lesson') }}</button>
            </div>
          </li>
        </ul>
      </template>
      <template v-else>
        <div class="box" v-show="!isLoading"></div>
      </template>
      </div>
    </div>
  </section>
</main>
</template>

<script>
  import {api} from "../../config";
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    props: {
      category: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        loading: false,
        section_data: {},
        lesson_list: [],
        learning_total: {}
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      isLoading () {
        return this.loading
      },
      lessonList() {
         return this.lesson_list
      },
    },
    
    created() {
      const self = this
      
      self.loading = false
      
      self.$store.dispatch('showLoading', true)
      
      self.learning_total = self.$store.getters.learning_total
      
      self.section_data = self.$store.getters.section[self.category];

      axios.get(api.lessons, {
        params: {
          section_id: self.section_data.section_id,
          section_status: 'all'
        }
      })
      .then((resp) => {
        const lessons = resp.data
        
        for(let lessonData of lessons) {
          let lesson_data = lessonData;
          let questionLog = self.learning_total.question.filter(item => {
              return (item.lesson_id == lessonData.lesson_id)
          })
          let questionExamLog = self.learning_total.question_exam.filter(item => {
              return (item.lesson_id == lessonData.lesson_id)
          })
          
          let count_data = { question: { correct_count: 0, answer_count: 0 }, exam: { correct_count: 0, answer_count: 0 }  }

          
          for(let questionData of questionLog) {
            count_data.question.correct_count += questionData.correct_count;
            count_data.question.answer_count += questionData.answer_count;
          }
          for(let questionData of questionExamLog) {
            count_data.exam.correct_count += questionData.correct_count;
            count_data.exam.answer_count += questionData.answer_count;
          }
          
          let question_rate = 0;
          let exam_rate = 0;
          if(count_data.question.correct_count && count_data.question.answer_count) {
            question_rate = Math.round((count_data.question.correct_count / count_data.question.answer_count) * 100);
          }
          if(count_data.exam.correct_count && count_data.exam.answer_count) {
            exam_rate = Math.round((count_data.exam.correct_count / count_data.exam.answer_count) * 100);
          }
          
          self.lesson_list.push({
            ...lessonData,
            question_rate: question_rate,
            exam_rate: exam_rate
          });
        }
        self.$store.dispatch('showLoading', false)
        self.loading = true
      
      })
      .catch(err => {
        self.$store.dispatch("showLoading", false);
        self.loading = true
      });
      
    },

    mounted() {
      
      const self = this
      
      self.loading = true
    },
    methods: {
      selectLessonItem(row) {
        // Locked lessons cannot be viewed
        if (row.status == 'incomplete') {
          return;
        }

        this.$store.dispatch('showLoading', true);
        this.$store.dispatch('setLessonData', row);
        this.$store.dispatch("setLessonStatus", row.status);

        // Update status the first time
        if (this.$store.getters.lesson_status == 'ready') {
          this.statusLesson('start');
        }

        // Get the contents of a Session or Exam
        let lessonData = this.$store.getters.lesson_data
        axios.get(api.contents, {
          params: {
            section_id: this.$store.getters.section_data.section_id,
            lesson_id: this.$store.getters.lesson_data.lesson_id,
            lesson_type: this.$store.getters.lesson_data.lesson_type
          }
        })
        .then((resp) => {
          this.$store.dispatch('setLessonContent',  resp.data)
          this.$store.dispatch('showLoading', false)

          let push_val = { name: 'lesson.movie', params: { lesson_id: lessonData.lesson_id, content_order: 1 }}
          if (lessonData.lesson_type == 'exam') {
            push_val = {name: 'lesson.explanation', params: { lesson_id: lessonData.lesson_id, step: 'exam' }}
          }
          this.$router.push(push_val)
        })
        .catch(err => {
          this.$store.dispatch("showLoading", false);
        });
      },
      back() {
        this.$router.push({name: 'profile.situation'})
      }
    },

  }
</script>
